import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const cleanEmail = f.email.trim().toLowerCase();
    const cleanName = f.name.trim();
    if (!cleanEmail || !f.password || !cleanName) { toast.error("Fill all fields"); return; }
    if (f.password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setLoading(true);
    try {
      await register(cleanName, cleanEmail, f.password);
      toast.success("Welcome to Outlaw-D");
      nav("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="register-page">
      <h1 className="font-display text-5xl">JOIN THE <span className="text-[#FF007F]">OUTLAW.</span></h1>
      <p className="font-mono-b text-sm mt-2 text-black/70">Create your account. Sell your fits. Shop the drops.</p>
      <form onSubmit={submit} className="mt-6 space-y-4" autoComplete="on">
        <div>
          <label className="text-xs font-mono-b font-bold uppercase">NAME</label>
          <input data-testid="register-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} type="text" required autoComplete="name" className="brutal-input w-full mt-1" />
        </div>
        <div>
          <label className="text-xs font-mono-b font-bold uppercase">EMAIL</label>
          <input data-testid="register-email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} type="email" required autoComplete="email" spellCheck={false} autoCapitalize="none" className="brutal-input w-full mt-1" />
        </div>
        <div>
          <label className="text-xs font-mono-b font-bold uppercase">PASSWORD</label>
          <div className="relative mt-1">
            <input
              data-testid="register-password"
              value={f.password}
              onChange={(e) => setF({ ...f, password: e.target.value })}
              type={showPw ? "text" : "password"}
              required
              minLength={6}
              autoComplete="new-password"
              className="brutal-input w-full pr-12"
            />
            <button
              type="button"
              data-testid="register-toggle-pw"
              onClick={() => setShowPw(!showPw)}
              aria-label={showPw ? "Hide password" : "Show password"}
              className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-black/70 hover:text-black"
            >
              {showPw ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
            </button>
          </div>
          <p className="text-xs font-mono-b text-black/60 mt-1">Min 6 characters.</p>
        </div>
        <button data-testid="register-submit" disabled={loading} type="submit" className="w-full bg-[#D4FF00] border-2 border-black brutal-shadow hover-nudge py-3 font-mono-b font-bold uppercase disabled:opacity-50">
          {loading ? "..." : "SIGN UP"}
        </button>
      </form>
      <p className="mt-6 text-sm font-mono-b">Got an account? <Link to="/login" className="underline font-bold">Log in</Link></p>
    </div>
  );
}
